// ProductContext.tsx
import React from 'react';

interface ProductContextType {
  pressedVar: any;
  pages: any;
  search: any;
  st_date: any;
  ed_date: any;
  jwtToken: any;
  userStatusData: any;
  selectLoc: (newSet: any) => void;
  setPages: (pageSet: any) => void;
  setPagesDecrement: () => void;
  setPagesIncrement: () => void;
  setJwtToken: (jwtToken: any) => void;
  goBackTopreviosState: (options: any) => void;
  prevState: any;
  statePusher: () => void;
  setSort: (options: any) => void;
  setSearch: (searchValue: any) => void;
  enteredText: any;
  setDateRanges: (ranges: any) => void;
  setPagesState: (options: any) => void;
  setUserToken: (options: any) => void;
  setStatusData: (options: any) => void;
  comeToiniStateDates: (options: any) => void;
  comeToiniStateSearch: (options: any) => void;
  setUserStatusState: (options: any) => void;
  modifyUserTableCols: (options: any) => void;
  removeAllStatus: () => void;
  setToggleStatus: (options: any) => void;
  openConfirmPopup: (options: any) => void;
  statusFilterDispatcher: (options: any) => void;
  closeConfirmPopup: () => void;
  removeTagsFromFilters: () => void;
  removeAllFilters: (options: any) => void;
  clientToken: any;
  primaryMemory: any;
  appliedFilters: any;
  sort_by: any;
  sort_order: any;
}

const ProductContext = React.createContext<ProductContextType | undefined>(undefined);

export default ProductContext;